export default {
  GATSBY_API_URL: process.env.GATSBY_API_URL || 'https://sandbox-admin.sygna.io/', // 'http://localhost:3000/',
  GATSBY_ENV: process.env.GATSBY_ENV,
};
